export function getValorDecimal(valor){
    let inicio = '';
    let fim = '';
    if(valor.length > 3){
        inicio = valor.slice(0, valor.length-3);
        fim = valor.slice(valor.length-3);
        inicio = inicio.replace('.','');
        fim = fim.replace(',','.');
    }else{
        inicio = valor.slice(0);
    }
    let novoValor = inicio+fim;
    return parseFloat(novoValor);
}

export function formatarValor(cents) {
    cents += '';
    let valor = '';
    let aux = cents.replace(/[.,]/g, '');
 
    if (aux !== cents)
        valor = (aux / 100).toFixed(2).toString().replace(".", ",");
    else
        valor = Number(aux).toFixed(2).toString().replace(".", ",");
 
    valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return valor;
    // return `${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
 }


// WEBPACK FOOTER //
// ./src/helpers/Monetario.js